import clsx from 'clsx';
import type { FC } from 'react';

import Icon from '@/components/Icon';
import Text from '@/components/Text';
import type { TransformApiCandidateResponse } from '@/services/externalCandidates';

type Props = {
  data: TransformApiCandidateResponse;
};

const ProfileBadge: FC<Props> = ({ data }) => {
  const resolveBadgeColor = (variant: boolean | 'primary') => {
    if (variant === 'primary') return 'bg-primary-500';
    if (variant) return 'bg-success';
    if (!variant) return 'bg-error';
  };

  const badgeItems = [
    {
      icon: 'material-symbols:hangout-video-outline-rounded',
      badgeColor: resolveBadgeColor(!!data.candidateDetailedInfo?.videoFile),
      value: null,
    },
    {
      icon: 'material-symbols:document-search-outline',
      badgeColor: resolveBadgeColor(!!data.cvFile),
      value: null,
    },
    {
      icon: 'ci:note',
      badgeColor: resolveBadgeColor('primary'),
      value: data.notes.length,
    },
    {
      icon: 'mdi:github',
      badgeColor: resolveBadgeColor(!!data.githubUrl),
      value: null,
    },
    {
      icon: 'material-symbols:folder-open-outline',
      badgeColor: resolveBadgeColor('primary'),
      value: data.collections.length,
    },
  ];
  return (
    <div className="flex w-full flex-row items-center justify-start gap-2 pt-3">
      {badgeItems.map(({ icon, value, badgeColor }) => (
        <div key={icon} className="relative rounded-full bg-neutral-200 p-1">
          <div
            className={clsx(
              'absolute -right-0.5 -top-0.5 flex aspect-square h-3 items-center justify-center rounded-full border-2 border-neutral-0',
              badgeColor,
              { 'h-5 -right-2 -top-2': typeof value === 'number' }
            )}
          >
            <Text
              variant="body-caption"
              className="text-center font-semibold text-neutral-0"
            >
              {value}
            </Text>
          </div>
          <Icon fontSize={22} icon={icon} className="text-neutral-900" />
        </div>
      ))}
    </div>
  );
};

export default ProfileBadge;
